import Contact from '../sections/Contact';
import { Seo, breadcrumbJsonLd } from '../lib/seo';

export default function ContactPage() {
  return (
    <>
      <Seo
        title="Request a Bid — Revive Builders LLC | (210) 393-1759"
        description="Request a bid from Revive Builders: apartment unit turns, make-readys, renovations, roofing, and commercial build-outs across San Antonio and Austin, TX. We'll walk it, scope it, and get you a number."
        path="/contact"
        jsonLd={[
          breadcrumbJsonLd([
            { name: 'Home', path: '/' },
            { name: 'Request a Bid', path: '/contact' },
          ]),
        ]}
      />
      <div className="pt-16">
        <Contact />
      </div>
    </>
  );
}
